import { createSelector } from 'reselect';

export const selectApp = () => state => state.get('app');

export const selectConfig = () => createSelector(
  selectApp(),
  appState => appState.get('config')
);
